import { render, staticRenderFns } from "./UniCourses.vue?vue&type=template&id=3fc9ad71&"
import script from "./UniCourses.vue?vue&type=script&lang=js&"
export * from "./UniCourses.vue?vue&type=script&lang=js&"
import style0 from "./UniCourses.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports